// extracted by mini-css-extract-plugin
module.exports = {"viewport":"WU+i7EYXNXyZ8l4t7FRZEw=="};